import { render } from "./PreviewElement.vue?vue&type=template&id=0f98b5a7&scoped=true"
import script from "./PreviewElement.vue?vue&type=script&lang=js"
export * from "./PreviewElement.vue?vue&type=script&lang=js"

import "./PreviewElement.vue?vue&type=style&index=0&id=0f98b5a7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f98b5a7"]])

export default __exports__